import React from 'react';
import './ModifierTrigger.less';
import {ModifierName} from 'new-components/elements/modifier-name/ModifierName';

export const ModifierTrigger = ({name, control, isSmall = false}) => {
	return (
		<div className={`modifier-trigger ${isSmall ? 'modifier-trigger--small' : ''}`}>
      <span className="modifier-trigger__name">
        <ModifierName text={name} isSmall={isSmall}/>
      </span>
			<span className="modifier-trigger__control">{control}</span>
		</div>
	);
};
